var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('EditRecurringEventForm',{attrs:{"initial-form-data":_vm.recurringEvent,"on-form-saved":_vm.onRecurringEventSaved}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }